import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@/contexts/AuthContext';
import { createApiClient } from '@/shared/api/apiClient';
import type { components } from '@/shared/api/openapi';

export interface UseBudgetGroupUserMembershipOptions {
  organizationId: number;
  groupId: number;
  userIds: string[];
  enabled?: boolean;
}

type BudgetGroupUserMembershipResult = components['schemas']['CheckBudgetGroupUserMembershipEndpoint_Response'];

export function useBudgetGroupUserMembership({ organizationId, groupId, userIds, enabled = true }: UseBudgetGroupUserMembershipOptions) {
  const { getAccessToken } = useAuth();

  return useQuery({
    queryKey: ['budget-group-user-membership', organizationId, groupId, userIds],
    queryFn: async ({ signal }) => {
      const client = createApiClient(getAccessToken, {
        cache: 'no-store',
        signal,
      });

      const { data, error } = await client.POST('/api/organizations/{organizationId}/budget-groups/{groupId}/users/check', {
        params: {
          path: { organizationId, groupId },
        },
        body: { userIds },
      });

      if (error) {
        throw error;
      }

      return (data ?? []) as BudgetGroupUserMembershipResult[];
    },
    enabled: enabled && userIds.length > 0,
    staleTime: 10000,
  });
}
